<template>
  <v-carousel
    cycle
    height="264"
    hide-delimiter-background
    show-arrows-on-hover
    v-if="slides.length > 0 && visible"
  >
    <v-icon
      class="d-flex justify-end"
      color="black"
      @click="handleVisible(false)"
      >mdi-close</v-icon
    >
    <v-carousel-item v-for="slide in slides" :key="slide.id">
      <v-sheet :color="slide.background_color" height="100%">
        <v-row class="fill-height d-flex">
          <v-col
            cols="12"
            class="text-h4 d-flex justify-center align-self-end"
            :style="{ color: slide.text_color }"
          >
            {{ slide.text }}
          </v-col>
          <v-col
            cols="12"
            class="text-h4 d-flex justify-center align-self-top"
            :style="{ color: slide.text_color, fontSize: '1.85rem !important' }"
          >
            {{ slide.description }}
          </v-col>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>
<script>
export default {
  props: {
    slides: [],
  },
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    handleVisible(value) {
      this.visible = value;
    },
  },
  //     slides: [
  //       {
  //         id: 1,
  //         provider: "0248 - PG4",
  //         color: "#cc2399",
  //         fontColor: "white",
  //         text: "Condição de pagamento especial 5x para pedidos até 31/08/2023",
  //       },
  //       {
  //         id: 2,
  //         provider: "0100 - FORNECEDOR TESTE",
  //         color: "red lighten",
  //         fontColor: "black",
  //         text: "Produtos com até 30% de desconto",
  //       },
  //     ],
  //   };
  // },
};
</script>
